module.exports = __webpack_public_path__ + "img/logo-um-ff.07d9f364.png";